exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._-Pmlj6YTsBZ0ZwWaZvko{border-top:1px solid hsla(210,2%,45%,.4)}._-Pmlj6YTsBZ0ZwWaZvko>a{padding:7px 10px!important}._27uAec8m5GMbbK4KEnVl7M{font-size:45px;padding:0;vertical-align:middle;color:#707274}._1iFNIbjVLu8TMq8Y9cpm7x{width:45px;float:left}._2BWGrMaEBiAJGLQOpl6ZDt{left:30px;color:#707274;min-height:20px}", ""]);

// exports
exports.locals = {
	"menuItem": "_-Pmlj6YTsBZ0ZwWaZvko",
	"menuItemIcon": "_27uAec8m5GMbbK4KEnVl7M",
	"menuItemIconDiv": "_1iFNIbjVLu8TMq8Y9cpm7x",
	"menuItemText": "_2BWGrMaEBiAJGLQOpl6ZDt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/styles/aoi/TypeaheadMenuItem.css
// module id = 1446
// module chunks = 1